function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Descriptions, Divider, Alert, Tag, Upload, Tabs } from 'antd';
import Common from "../includes/Common";
import Webcam from "react-webcam";
import { Paperclip, HandIndexFill, ArrowClockwise, Upload as UploadIc, CameraFill } from "react-bootstrap-icons";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var SetImFile = function SetImFile(_ref) {
  var q_item = _ref.q_item,
    m_item = _ref.m_item,
    im_type = _ref.im_type,
    handler = _ref.handler;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormProcessing = _useState2[0],
    setIsFormProcessing = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    successMessage = _useState6[0],
    setSuccessMessage = _useState6[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState7 = useState(1),
    _useState8 = _slicedToArray(_useState7, 2),
    fileType = _useState8[0],
    setFileType = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    imFile = _useState0[0],
    setImFile = _useState0[1];
  var props = {
    onRemove: function onRemove(file) {
      setImFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setImFile(file);
      return false;
    },
    accept: ".png,.jpg,.jpeg",
    maxCount: 1
  };
  var handleFileTabChange = function handleFileTabChange(key) {
    setFileType(key);
  };
  var tabItems = [{
    key: 1,
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(Paperclip, {
        size: 25
      }), " FICHIER JOINT"]
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Upload, _objectSpread(_objectSpread({}, props), {}, {
        children: /*#__PURE__*/_jsx(Button, {
          type: "primary",
          icon: /*#__PURE__*/_jsx(UploadIc, {
            size: 20
          }),
          children: /*#__PURE__*/_jsx("b", {
            children: "Joindre le courrier"
          })
        })
      }))
    })
  }, {
    key: 2,
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(CameraFill, {
        size: 25
      }), " APPAREIL PHOTO"]
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: imFile == null ? /*#__PURE__*/_jsx(Webcam, {
        audio: false,
        height: 300,
        mirrored: true,
        screenshotFormat: "image/png",
        width: 380,
        children: function children(_ref2) {
          var getScreenshot = _ref2.getScreenshot;
          return /*#__PURE__*/_jsx(Button, {
            type: "default",
            icon: /*#__PURE__*/_jsx(HandIndexFill, {
              size: 22
            }),
            onClick: function onClick() {
              var imageSrc = getScreenshot();
              setImFile(imageSrc);
            },
            children: "Capturer le clichet"
          });
        }
      }) : /*#__PURE__*/_jsxs("div", {
        style: {
          width: '380px'
        },
        children: [/*#__PURE__*/_jsx("img", {
          src: imFile
        }), /*#__PURE__*/_jsx(Button, {
          type: "default",
          onClick: function onClick() {
            setImFile(null);
          },
          icon: /*#__PURE__*/_jsx(ArrowClockwise, {
            size: 20
          }),
          children: /*#__PURE__*/_jsx("b", {
            children: "Reprendre"
          })
        })]
      })
    })
  }];
  var onFinish = function onFinish(values) {
    setErrorMessage('');
    setSuccessMessage('');
    setIsFormProcessing(true);
    var formData = new FormData();
    formData.append("user_id", Common.currentUser.id);
    formData.append("file", imFile);
    formData.append("medical_item_id", m_item.id);
    formData.append("customer_id", q_item.customer_id);
    formData.append("im_source", fileType);
    formData.append("type", im_type);
    formData.append("queue_item_id", q_item.id.toString());
    axios.post(Common.baseApiUrl + "setimagefile", formData).then(function (response) {
      if (response.data.status == 200) {
        setSuccessMessage("Résultats saisis avec succès");
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  useEffect(function () {}, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Descriptions, {
      size: "small",
      bordered: true,
      column: 1,
      children: [/*#__PURE__*/_jsx(Descriptions.Item, {
        label: "Examen demand\xE9",
        children: m_item != null && /*#__PURE__*/_jsx(Tag, {
          color: "red",
          children: /*#__PURE__*/_jsx("b", {
            children: m_item.label
          })
        })
      }), /*#__PURE__*/_jsx(Descriptions.Item, {
        label: "Medecin prescripteur"
      })]
    }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: errorMessage,
          banner: true
        })
      }), /*#__PURE__*/_jsx(Tabs, {
        destroyInactiveTabPane: true,
        onChange: handleFileTabChange,
        items: tabItems
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormProcessing,
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "SAUVEGARDER"
          })
        })
      })]
    })]
  });
};
export default SetImFile;